Ext.ns('mx.plugin');

mx.plugin.DateTimeValidate = function(config) {
    Ext.apply(this, config);
};

Ext.extend(mx.plugin.DateTimeValidate, Ext.util.Observable, {
    init: function(datetime) {
        if (datetime.range == 'left') {
            this.left = datetime;
        } else if (datetime.range == 'right') {
            this.right = datetime;
        }

        var markInvalid = function(object) {
            object.tf.markInvalid(this.incorrectTimeWindowMessage || 'Incorrect time window');
            object.df.markInvalid(this.incorrectTimeWindowMessage || 'Incorrect time window');
        };

        var validate = function(leftRange, rightRange) {
            if (leftRange.getValue() && rightRange.getValue()) {
                if (leftRange.df.getValue() && rightRange.df.getValue()) {
                    if (leftRange.df.getValue().getTime() > rightRange.df.getValue().getTime()) {
                        markInvalid(leftRange);
                        markInvalid(rightRange);
                        return false;
                    } else if (leftRange.tf.getValue() && rightRange.tf.getValue()) {
                        if (leftRange.getValue() >= rightRange.getValue()) {
                            markInvalid(leftRange);
                            markInvalid(rightRange);
                            return false;
                        }
                    }
                }
            }
            return true;
        };

        if (this.left && this.right) {
            this.left.rightRange = this.right;
            this.right.leftRange = this.left;
            var originalLeftValidation = this.left.validate;
            this.left.validate = function() {
                if (originalLeftValidation.apply(this, arguments)) {
                    return validate(this, this.rightRange);
                }
            };
            var originalRightValidation = this.right.validate;
            this.right.validate = function() {
                if (originalRightValidation.apply(this, arguments)) {
                    return validate(this.leftRange, this);
                }
            };
        }
    },
});
